import React, { useState, useEffect } from 'react';
import { 
  Menu, X, Instagram, MessageCircle, 
  TrendingUp, Globe, Video, Palette, Target, 
  ChevronDown, Star, Users, CheckCircle,
  ArrowRight, Sparkles, Eye
} from 'lucide-react';

// Assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/wzhkeqtk_REDES%20MODO%20FACIL%20-%20BLANCO.png";
const PHOTO_URL = "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/nrj4beld_WhatsApp%20Image%202024-08-26%20at%206.56.17%20PM.jpeg";
const MOUNTAIN_PHOTO_URL = "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/q4r2nbkg_imgi_24_296286997_355461113456380_8682985139084758470_n.webp";

// Portfolio images
const PORTFOLIO_IMAGES = [
  {
    url: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/5212s195_imgi_4_9sha3v9x_imgi_42_oEAAuL4Xl3iKG38AjePEbtIfAoIbDDAIrRBAEf.jpg",
    title: "Mi cliente #1 en Google Maps"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/i50w1093_imgi_6_6accbkmh_imgi_41_okCUEEBvyBAMFlArAgi4gIzADCpo9B8eIQvMoi.jpg",
    title: "Mis diseños en la cancha de River"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/82rtrkvd_imgi_7_6mq3oic5_imgi_147_o0A3amO8DIDrjuvqAeFAUvRztCfKoABEEig2E7.jpg",
    title: "Lo que TikTok valora para ser viral"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/8b46wan5_imgi_5_rmungxr6_imgi_84_oQ2jNUf8AAAfAG3oAILW73QGnejtPf7IGRJH3Q.jpg",
    title: "Siempre es estrategia"
  }
];

// WhatsApp URL
const WHATSAPP_URL = "https://wa.me/5491169377708?text=Hola%20Gonzalo,%20quiero%20consultar%20por%20tus%20servicios";

// TikTok URL
const TIKTOK_URL = "https://www.tiktok.com/@redesmodofacil";

// Brand logos - con URLs de logos
const BRANDS = [
  { name: "POSTA", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/dqqt6293_imgi_8_z9ww5l9t_Logo%20Positivo%20-%20POSTA.png" },
  { name: "Tome y Traiga", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/waxw4pyf_imgi_9_qrz41w4f_logo%20t%2526t%20tome%20y%20traiga%20%284%29%20%281%29%20copiaa%20copia.png" },
  { name: "Alef", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/l1h4vwjp_imgi_10_luqp06hg_Logo%20Blanco.png" },
  { name: "El Cometa Bis", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/aayia7vk_imgi_14_nlun2gfi_Logo%20en%20Alta%20V.2%20-%20PNG-01.png" },
  { name: "Move Concerts", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/7eou4aj6_imgi_16_uk3zztgh_movec.png" },
  { name: "Destino Salta", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/zfv4go0t_imgi_12_04a69v68_logo%20blanco%20destino%20salta.png" },
  { name: "DJ Kezla", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/0rnxauzt_imgi_13_go8q7tfr_LOGOTIPO%20CORTO%20BLANCO1.png" },
  { name: "Mudanza Caba", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/hrzs01tt_imgi_15_nit7o954_mudanzacaba.png" },
  { name: "Livepass", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/6bplqclx_imgi_17_1j5a7tti_livepass.png" },
  { name: "Parrilla Fogosa", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/co61efc8_imgi_18_ivqjinwh_Fogosa.png" },
  { name: "Orlan Rodera", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/pc20bn1r_imgi_19_t91uqnpl_Orlan%20Rober.png" },
  { name: "D10S Media", logo: "https://customer-assets.emergentagent.com/job_landing-update-4/artifacts/gmcx6dpv_imgi_11_7u94l0gb_D10S%20Media%20-%20White.png" }
];

// TikTok Icon Component
const TikTokIcon = ({ size = 20, className = "" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    className={className}
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// Navigation Component
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#sobre-mi', label: 'Sobre Mí' },
    { href: '#servicios', label: 'Servicios' },
    { href: '#resultados', label: 'Portfolio' },
    { href: '#marcas', label: 'Marcas' },
    { href: '#contacto', label: 'Contacto' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
    }`} data-testid="navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a href="#" className="flex items-center" data-testid="logo" aria-label="RedesModoFacil - Ir al inicio">
            <img 
              src={LOGO_URL} 
              alt="Logo RedesModoFacil - Estrategia en Redes Sociales" 
              className={`h-14 w-auto transition-all ${scrolled ? 'brightness-0' : 'brightness-100'}`}
              width="140"
              height="56"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`font-medium transition-colors hover:text-[#3a86ff] ${
                  scrolled ? 'text-gray-700' : 'text-white/90'
                }`}
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn px-6 py-2.5 rounded-full text-white font-semibold flex items-center gap-2"
              data-testid="nav-whatsapp-btn"
            >
              <MessageCircle size={18} />
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? (
              <X className={scrolled ? 'text-[#142850]' : 'text-white'} size={28} />
            ) : (
              <Menu className={scrolled ? 'text-[#142850]' : 'text-white'} size={28} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white rounded-2xl shadow-2xl p-6 mt-2 animate-fadeInUp" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="block py-3 text-gray-700 font-medium hover:text-[#3a86ff]"
              >
                {link.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn mt-4 w-full py-3 rounded-full text-white font-semibold flex items-center justify-center gap-2"
            >
              <MessageCircle size={18} />
              Contactar por WhatsApp
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-[#142850] via-[#1a3a6e] to-[#142850] overflow-hidden" data-testid="hero-section">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#3a86ff]/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#3a86ff]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <Sparkles className="text-[#3a86ff]" size={18} />
              <span className="text-white/90 text-sm font-medium">+5 años de experiencia</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-6" data-testid="hero-title">
              Gonzalo Garcia
              <span className="block text-[#3a86ff]">Estrategia en Redes</span>
            </h1>
            
            <p className="text-lg md:text-xl text-white/80 mb-8 max-w-xl mx-auto lg:mx-0" data-testid="hero-subtitle">
              Transformo tu presencia digital en resultados reales y crecimiento orgánico verificable.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn px-8 py-4 rounded-full text-white font-bold text-lg flex items-center justify-center gap-2 group"
                data-testid="hero-cta-btn"
              >
                Comenzar Ahora
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </a>
              <a
                href="#resultados"
                className="px-8 py-4 rounded-full border-2 border-white/30 text-white font-bold hover:bg-white/10 transition-colors flex items-center justify-center gap-2"
                data-testid="hero-results-btn"
              >
                Ver Portfolio
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-12">
              <div className="text-center lg:text-left">
                <div className="text-3xl md:text-4xl font-bold text-white">+5</div>
                <div className="text-white/60 text-sm">Años de Experiencia</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl md:text-4xl font-bold text-white">+20</div>
                <div className="text-white/60 text-sm">Marcas Reales</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-3xl md:text-4xl font-bold text-white">+10M</div>
                <div className="text-white/60 text-sm">Visitas Orgánicas</div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative hidden lg:flex justify-center items-center">
            <div className="relative">
              {/* Glowing background */}
              <div className="absolute inset-0 bg-[#3a86ff]/30 rounded-full blur-3xl scale-110 animate-pulse"></div>
              
              {/* Photo container */}
              <div className="relative w-80 h-80 rounded-full overflow-hidden border-4 border-white/20 shadow-2xl">
                <img 
                  src={PHOTO_URL} 
                  alt="Gonzalo Garcia - Especialista en Estrategia de Redes Sociales - RedesModoFacil" 
                  className="w-full h-full object-cover"
                  loading="eager"
                />
              </div>

              {/* Floating cards */}
              <div className="absolute top-0 right-0 bg-white/10 backdrop-blur-md p-4 rounded-2xl animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                    <TrendingUp className="text-white" size={24} />
                  </div>
                  <div>
                    <div className="text-white font-bold">+10M</div>
                    <div className="text-white/60 text-sm">Visitas</div>
                  </div>
                </div>
              </div>
              
              <div className="absolute bottom-10 -left-10 bg-white/10 backdrop-blur-md p-4 rounded-2xl animate-float" style={{animationDelay: '1s'}}>
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-[#3a86ff] rounded-full flex items-center justify-center">
                    <Eye className="text-white" size={24} />
                  </div>
                  <div>
                    <div className="text-white font-bold">100%</div>
                    <div className="text-white/60 text-sm">Orgánico</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white/50" size={32} />
      </div>
    </section>
  );
};

// About Me Section (Sobre Mí - Singular)
const AboutSection = () => {
  const diferencias = [
    "Resultados orgánicos verificables, no bots ni seguidores falsos",
    "Transparencia total en procesos y métricas reales",
    "Estrategias probadas en +20 marcas de diferentes rubros",
    "Respuesta rápida y compromiso real con tu proyecto",
    "Trabajo con clientes de todo el mundo"
  ];

  return (
    <section id="sobre-mi" className="py-24 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-2 bg-[#3a86ff]/10 rounded-full text-[#3a86ff] font-semibold text-sm mb-4">
            SOBRE MÍ
          </span>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Photo */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={MOUNTAIN_PHOTO_URL} 
                alt="Gonzalo Garcia en Salta, Argentina - Fundador de RedesModoFacil - Estratega de Redes Sociales" 
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#142850] mb-4">
              ¿Quién Soy?
            </h2>
            <h3 className="text-xl text-[#3a86ff] font-semibold mb-6">
              Gonzalo Garcia - @redesmodofacil
            </h3>
            
            <div className="space-y-4 text-gray-600 mb-8">
              <p>
                Soy especialista en Estrategia de Redes Sociales, enfocado en hacer crecer marcas de forma orgánica y real. Crecí en Salta con un sueño: ayudar a negocios a destacarse en redes sociales de manera auténtica.
              </p>
              <p>
                Me formé en Buenos Aires trabajando con las mejores agencias del país. Ahí aprendí, crecí y construí un método que realmente funciona. El éxito que logré me dio la posibilidad de volver a mi tierra, Salta, y seguir trabajando desde donde más me gusta.
              </p>
              <p>
                Hoy, con más de <strong>5 años de experiencia</strong>, muestro <strong>mis procesos reales</strong> en TikTok e Instagram. Mis clientes me eligen porque ven exactamente cómo trabajo antes de contratarme. He llevado cuentas de <strong>5K a +50K seguidores en menos de 3 meses</strong> de forma orgánica, creé diseños que se mostraron en el <strong className="text-[#3a86ff]">Estadio Monumental de River</strong> y generé millones de reproducciones sin gastar en bots.
              </p>
            </div>

            {/* Por qué soy diferente */}
            <div className="bg-gray-50 p-6 rounded-2xl">
              <h4 className="text-lg font-bold text-[#142850] mb-4">¿Por qué soy diferente?</h4>
              <ul className="space-y-3">
                {diferencias.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <CheckCircle className="text-[#3a86ff] mt-0.5 flex-shrink-0" size={20} />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-8">
              <a
                href={`https://wa.me/5491169377708?text=Hola%20Gonzalo,%20quiero%20hablar%20sobre%20mi%20proyecto`}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-btn inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold"
                data-testid="about-cta-btn"
              >
                Hablemos de tu proyecto
                <ArrowRight size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  const services = [
    {
      icon: <Globe className="text-[#3a86ff]" size={32} />,
      title: "Diseño Web",
      description: "Creo landing pages y sitios web que generan confianza y venden 24/7, optimizados para conversión real.",
      features: ["Landing Pages", "Sitios Web", "Optimización SEO"]
    },
    {
      icon: <Video className="text-[#3a86ff]" size={32} />,
      title: "Edición de Video",
      description: "Edito reels, TikToks y shorts con técnicas que hacen que la gente se quede hasta el final y comparta.",
      features: ["Reels", "TikToks", "YouTube Shorts"]
    },
    {
      icon: <Palette className="text-[#3a86ff]" size={32} />,
      title: "Diseño Gráfico",
      description: "Diseños profesionales que destacan: posts, stories, flyers y piezas que hacen que tu marca se vea premium.",
      features: ["Posts", "Stories", "Branding"]
    },
    {
      icon: <Target className="text-[#3a86ff]" size={32} />,
      title: "Campañas de Ads",
      description: "Meta Ads y Google Ads optimizados para ROI: cada peso invertido se traduce en leads y ventas reales.",
      features: ["Meta Ads", "Google Ads", "Retargeting"]
    },
    {
      icon: <TrendingUp className="text-[#3a86ff]" size={32} />,
      title: "Community Management",
      description: "Gestión completa de tus redes sociales con estrategias de crecimiento orgánico probadas.",
      features: ["Instagram", "Facebook", "TikTok"]
    },
    {
      icon: <Users className="text-[#3a86ff]" size={32} />,
      title: "Asesoría 1:1",
      description: "Sesiones personalizadas para freelancers y emprendedores que quieren aprender a vender en redes.",
      features: ["Estrategia", "Mentoría", "Seguimiento"]
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-gray-50 to-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#3a86ff]/10 rounded-full text-[#3a86ff] font-semibold text-sm mb-4">
            SERVICIOS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#142850] mb-4" data-testid="services-title">
            Servicios que Resuelven<br />
            <span className="text-[#3a86ff]">Problemas Reales</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Tecnología de última generación + experiencia real = resultados profesionales que compiten con agencias premium.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card bg-white p-8 rounded-2xl shadow-lg border border-gray-100 group"
              data-testid={`service-card-${index}`}
            >
              <div className="w-16 h-16 bg-[#3a86ff]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-[#142850] mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <div className="flex flex-wrap gap-2">
                {service.features.map((feature, i) => (
                  <span
                    key={i}
                    className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={`${WHATSAPP_URL.replace('consultar%20por%20tus%20servicios', 'me%20interesa%20el%20servicio%20de%20')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold"
            data-testid="services-cta-btn"
          >
            Consultar Servicios
            <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

// Results/Portfolio Section with TikTok thumbnails
const ResultsSection = () => {
  const floatClasses = [
    'animate-float-card-1',
    'animate-float-card-2',
    'animate-float-card-3',
    'animate-float-card-4'
  ];

  return (
    <section id="resultados" className="py-24 bg-gradient-to-b from-white to-gray-50" data-testid="results-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#3a86ff]/10 rounded-full text-[#3a86ff] font-semibold text-sm mb-4">
            PORTFOLIO
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#142850] mb-4" data-testid="results-title">
            Portfolio Real
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Casos de éxito verificables. Apretá en 'Ver Más' para ver el proceso completo en TikTok.
          </p>
        </div>

        {/* Portfolio Grid with TikTok thumbnails */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {PORTFOLIO_IMAGES.map((item, index) => (
            <a
              key={index}
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`relative aspect-[9/16] rounded-2xl overflow-hidden group cursor-pointer shadow-lg ${floatClasses[index]}`}
              data-testid={`portfolio-item-${index}`}
            >
              {/* Background Image with low opacity */}
              <img 
                src={item.url}
                alt={`${item.title} - Portfolio de RedesModoFacil - Caso de éxito en TikTok`}
                className="absolute inset-0 w-full h-full object-cover opacity-40"
                loading="lazy"
              />
              
              {/* Blue gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-[#142850]/80 via-[#1a3a6e]/70 to-[#3a86ff]/80"></div>
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4 text-center">
                <TikTokIcon size={48} className="text-white mb-4 opacity-80 group-hover:scale-110 transition-transform" />
                <span className="text-white font-bold text-sm md:text-base opacity-0 group-hover:opacity-100 transition-opacity">
                  Ver en TikTok
                </span>
              </div>
              
              {/* Hover effect */}
              <div className="absolute inset-0 bg-[#3a86ff]/20 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-500 mb-6">¿Querés ver todos mis trabajos y procesos?</p>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold"
            data-testid="results-tiktok-btn"
          >
            <TikTokIcon size={20} />
            Ver más proyectos en TikTok
            <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

// Brands Section
const BrandsSection = () => {
  const floatClasses = [
    'animate-float-brand-1', 'animate-float-brand-2', 'animate-float-brand-3', 'animate-float-brand-4',
    'animate-float-brand-5', 'animate-float-brand-6', 'animate-float-brand-7', 'animate-float-brand-8',
    'animate-float-brand-9', 'animate-float-brand-10', 'animate-float-brand-11', 'animate-float-brand-12'
  ];

  return (
    <section id="marcas" className="py-24 bg-[#142850]" data-testid="brands-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-testid="brands-title">
            Marcas que Confían en Mí
          </h2>
          <p className="text-white/60 text-lg">
            Empresas reales que vieron resultados verificables
          </p>
        </div>

        {/* Brand Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {BRANDS.map((brand, index) => (
            <div
              key={index}
              className={`bg-white/10 backdrop-blur-sm rounded-xl p-6 flex items-center justify-center min-h-[120px] hover:bg-white/20 transition-colors ${floatClasses[index]}`}
              data-testid={`brand-${index}`}
            >
              {brand.logo ? (
                <img 
                  src={brand.logo} 
                  alt={`Logo de ${brand.name} - Cliente de RedesModoFacil`}
                  className="max-h-20 w-auto object-contain"
                  loading="lazy"
                />
              ) : (
                <span className="text-white font-bold text-lg text-center">{brand.name}</span>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-white/60 mb-6">Tu marca podría ser la próxima en esta lista</p>
          <a
            href={`https://wa.me/5491169377708?text=Hola%20Gonzalo,%20quiero%20trabajar%20juntos`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-[#142850] rounded-full font-bold hover:bg-gray-100 transition-colors"
            data-testid="brands-cta-btn"
          >
            Trabajemos Juntos
            <ArrowRight size={20} />
          </a>
        </div>
      </div>
    </section>
  );
};

// Ideal Client Section
const IdealClientSection = () => {
  const idealFor = [
    "Freelancers que quieren aprender a vender servicios en redes",
    "Emprendedores que buscan crecer su marca de forma orgánica",
    "Marcas que valoran la transparencia y los resultados verificables",
    "Negocios que quieren estrategias probadas, no promesas vacías"
  ];

  const notFor = [
    "Querés resultados de la noche a la mañana sin trabajar",
    "Preferís comprar seguidores falsos que construir real",
    "No valorás el proceso ni la estrategia a largo plazo"
  ];

  return (
    <section className="py-24 bg-gray-50" data-testid="ideal-client-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500">
            <h3 className="text-2xl font-bold text-[#142850] mb-6 flex items-center gap-3">
              <CheckCircle className="text-green-500" size={28} />
              Esto es para vos si...
            </h3>
            <ul className="space-y-4">
              {idealFor.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-green-500 mt-1 flex-shrink-0" size={20} />
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-500">
            <h3 className="text-2xl font-bold text-[#142850] mb-6 flex items-center gap-3">
              <X className="text-red-500" size={28} />
              Esto no es para vos si...
            </h3>
            <ul className="space-y-4">
              {notFor.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <X className="text-red-500 mt-1 flex-shrink-0" size={20} />
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

// CTA Section
const CTASection = () => {
  return (
    <section id="contacto" className="py-24 bg-gradient-to-br from-[#142850] to-[#1a3a6e]" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-testid="cta-title">
          ¿Listo para Crecer<br />
          <span className="text-[#3a86ff]">de Verdad?</span>
        </h2>
        <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
          Dale a tu marca la presencia digital que merece. Sin promesas vacías, solo estrategias que funcionan y resultados reales.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn px-8 py-4 rounded-full text-white font-bold text-lg flex items-center justify-center gap-3"
            data-testid="cta-whatsapp-btn"
          >
            <MessageCircle size={24} />
            Contactar por WhatsApp
          </a>
        </div>

        <p className="text-white/50 text-sm mt-8">
          No prometo hacerte viral de la noche a la mañana. Prometo trabajo serio, estrategia probada y crecimiento real y sostenible.
        </p>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer className="bg-[#0d1f3c] py-12" data-testid="footer" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <img 
              src={LOGO_URL} 
              alt="Logo RedesModoFacil" 
              className="h-8 w-auto"
              loading="lazy"
            />
          </div>

          <nav aria-label="Redes sociales">
            <div className="flex items-center gap-6">
              <a
                href="https://instagram.com/redesmodofacil"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="footer-instagram"
                aria-label="Seguir a RedesModoFacil en Instagram"
              >
                <Instagram className="text-white" size={20} aria-hidden="true" />
              </a>
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="footer-tiktok"
                aria-label="Seguir a RedesModoFacil en TikTok"
              >
                <TikTokIcon size={20} className="text-white" />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="footer-whatsapp"
                aria-label="Contactar a RedesModoFacil por WhatsApp"
              >
                <MessageCircle className="text-white" size={20} aria-hidden="true" />
              </a>
            </div>
          </nav>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8 text-center">
          <p className="text-white/50 text-sm">
            Ayudando a freelancers, emprendedores y marcas a crecer en redes sociales con resultados orgánicos verificables.
          </p>
          <p className="text-white/30 text-sm mt-4">
            © {new Date().getFullYear()} RedesModoFacil. Diseñado con pasión para generar resultados reales.
          </p>
        </div>
      </div>
    </footer>
  );
};

// Floating WhatsApp Button
const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform animate-pulse-glow"
      data-testid="floating-whatsapp"
      aria-label="Contactar por WhatsApp a RedesModoFacil"
    >
      <MessageCircle className="text-white" size={32} aria-hidden="true" />
    </a>
  );
};

// Main App Component
function App() {
  return (
    <div className="App font-montserrat" data-testid="app">
      <Navigation />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ResultsSection />
        <BrandsSection />
        <IdealClientSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
